import React from "react";
import { ErrorMessage, Checkbox as BronsonCheckbox } from "@vwfs-bronson/bronson-react";
import { GenericFieldHTMLAttributes, useField } from "formik";
import { FormField } from "@common/types";

interface Props {
  formField: FormField;
  label: React.ReactNode;
}

export const Checkbox: React.FC<Props & Omit<GenericFieldHTMLAttributes, "name">> = ({ formField, label, ...props }) => {
  const { fieldName } = formField;
  const [{ value, onBlur }, { touched, error }, { setValue }] = useField<boolean>({
    name: fieldName,
    type: "checkbox",
  });

  const errorMessage = touched && error ? <ErrorMessage id={fieldName}>{error}</ErrorMessage> : null;

  return (
    <>
      <BronsonCheckbox
        name={fieldName}
        errorMessage={errorMessage}
        checked={value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setValue(event.target.checked);
        }}
        onBlur={onBlur}
        aria-describedby={`error-${fieldName}`}
      >
        {label}
      </BronsonCheckbox>
      {errorMessage}
    </>
  );
};
